import React from "react";
import { CartItem } from "../types";

type Props = {
  item: CartItem;
  onQuantityChange: (productId: string, delta: number) => void;
  onRemove: (productId: string) => void;
};

const container: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 12,
  padding: 8,
  borderBottom: "1px solid #2a2a2a",
};
const thumb: React.CSSProperties = {
  width: 48,
  height: 48,
  objectFit: "cover",
  borderRadius: 4,
};
const info: React.CSSProperties = { flex: 1 };
const name: React.CSSProperties = { color: "#fff", fontSize: 14, margin: 0 };
const price: React.CSSProperties = {
  color: "#ddd",
  fontSize: 12,
  marginTop: 4,
};
const qtyGroup: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 6,
};

export const CartItemComponent: React.FC<Props> = ({
  item,
  onQuantityChange,
  onRemove,
}) => {
  return (
    <div style={container}>
      <img src={item.product.image} alt={item.product.name} style={thumb} />
      <div style={info}>
        <p style={name}>{item.product.name}</p>
        <p style={price}>${item.product.price.toFixed(2)} ea</p>
      </div>
      <div style={qtyGroup}>
        <button
          onClick={() => onQuantityChange(item.product.id, -1)}
          style={ghostBtnStyle}
          aria-label={`Decrease quantity of ${item.product.name}`}
        >
          -
        </button>
        <span style={{ width: 20, textAlign: "center" }}>{item.quantity}</span>
        <button
          onClick={() => onQuantityChange(item.product.id, 1)}
          style={ghostBtnStyle}
          aria-label={`Increase quantity of ${item.product.name}`}
        >
          +
        </button>
        <button
          onClick={() => onRemove(item.product.id)}
          style={removeBtnStyle}
        >
          Remove
        </button>
      </div>
    </div>
  );
};

const ghostBtnStyle: React.CSSProperties = {
  background: "transparent",
  color: "#fff",
  border: "1px solid #2a2a2a",
  borderRadius: 4,
  padding: "4px 8px",
  cursor: "pointer",
};
const removeBtnStyle: React.CSSProperties = {
  ...ghostBtnStyle,
  background: "#3a1f1f",
  borderColor: "#5a2a2a",
  marginLeft: 6,
};

export default CartItemComponent;
